//@ts-ignore
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import _ from "lodash";
import styled from "styled-components";

import { arrayToOptions, interferance } from "components/pages/search-results-page";
import PaginationControl from "components/tools/pagination-control";
import { Control } from "components/ui-kit/control";
import { Breadcrumb, Container, Frame, RowWrapper } from "components/ui-kit/styled-templates";

import { resolveFileUrl } from "constants/config";

import EventsApi from "api/events-api";
import RoomsApi from "api/rooms-api";
import ClubApi from "api/clubs-api";

import useBodyBackground from "hooks/useBodyBackground";
import useFormControl from "hooks/useFormControl";
import usePagination from "hooks/usePagination";
import { useStorageListener } from "hooks/useStorage";

import { EForms } from "types/enums";
import UniversityApi from "../../api/university-api";

const ClubsPage = () => {
    const { t } = useTranslation();

    useBodyBackground("white");

    const { data: search } = useFormControl({ name: EForms.clubsSearch });

    let clubs = useStorageListener(`clubs`, {});
    const universMap = useStorageListener(`universities`, {});
    const events = useStorageListener(`events`, {});

    // Функция для получения события с самой поздней датой окончания (прошедшего модерацию)
    const getLatestEndingEvent = (universityId: string) => {
        const now = Date.now();
        const clubEvents = _.values(events)
            .filter((event: any) =>
                event.universityId === universityId &&
                event.onModeration !== true &&
                event.hideFromAll !== true &&
                (event.details?.dates?.to || event.details?.dates?.from) >= now
            )
            .sort((a: any, b: any) => (b.details?.dates?.to || b.details?.dates?.from || 0) - (a.details?.dates?.to || a.details?.dates?.from || 0));

        return clubEvents[0] || null;
    };

    // @ts-ignore
    // let clubsUniversOptions = (Object.values(clubs) || []).map(x => {
    //     let val = (x || {}).universityId;
    //     let uni = universMap[val];
    //     return {
    //         value: (x || {}).universityId,
    //         label: uni?.details?.name
    //         // ...x,
    //         // university: universMap[x.universityId]
    //     }
    // });
    let clubsUniversOptions = [];
    for (let key in clubs){
        let val = clubs[key].universityId;
        let uni = universMap[val];
        clubsUniversOptions.push({
            value: clubs[key].universityId,
            label: uni?.details?.name
        });
    }

    // console.log('render: univers = ', univers);
    // let clubsFilterO

    console.log('render: clubs = ', clubs);

    let filteredClubs = _(clubs)
        .filter(interferance("details.region", search.region))
        .filter(interferance("details.city", search.city))
        .filter(interferance("universityId", search.universityId))
        .value();

    console.log('filteredClubs = ', filteredClubs);

    console.log('render: search = ', search);

    // console.log('filteredClubs = ', filteredClubs);
    // filteredClubs = filteredClubs.filter(x => (x?.hideFromAll != true));
    // filteredClubs = filteredClubs;

    // Сортировка клубов: сначала те, у которых событие заканчивается позже всех
    filteredClubs = filteredClubs.sort((a, b) => {
        const eventA = getLatestEndingEvent(a.universityId);
        const eventB = getLatestEndingEvent(b.universityId);

        // Клубы с предстоящими событиями идут первыми
        if (eventA && !eventB) return -1;
        if (!eventA && eventB) return 1;

        // Оба имеют события — сортировать по дате окончания (позже = выше)
        if (eventA && eventB) {
            const endA = eventA.details?.dates?.to || eventA.details?.dates?.from || 0;
            const endB = eventB.details?.dates?.to || eventB.details?.dates?.from || 0;
            return endB - endA;
        }

        // Оба без событий — оставить как есть
        return 0;
    });

    const pagination = usePagination(_.values(filteredClubs), { perPage: 9 });
    const { visibleItems: visibleClubs } = pagination;

    // @ts-ignore
    useEffect(ClubApi.getAllClubsData, []);
    // @ts-ignore
    useEffect(RoomsApi.getAllRooms, []);
    // @ts-ignore
    useEffect(EventsApi.getEvents, []);
    // @ts-ignore
    useEffect(UniversityApi.getAllUniversitiesData, []);

    const filteredOptions = {
        region: _(filteredClubs).map("details.region").uniq().map(arrayToOptions).orderBy("label", "asc").value(),
        city: _(filteredClubs).map("details.city").uniq().map(arrayToOptions).orderBy("label", "asc").value(),
        universityId: clubsUniversOptions
    };

    let filteredRegions = (filteredOptions?.region || []).sort((a, b) => {
        let s1 = a.value;
        let s2 = b.value;
        if (s1.indexOf('ЕА') > -1){
            s1 = `_${s1}`;
        }
        if (s2.indexOf('ЕА') > -1){
            s2 = `_${s2}`;
        }
        if (s1 > s2) {
            return 1;
        }
        if (s1 < s2) {
            return -1;
        }
        return 0;
    });

    console.log('render: filteredOptions.city = ', filteredOptions.city);

    return (
        <>
            <Container extra="align-items: flex-start; h1 { margin: 0; };">
                <Breadcrumb.Wrapper>
                    <Breadcrumb.Item to="/">{t("s7kasboi06")}</Breadcrumb.Item>
                    <Breadcrumb.Item to="/clubs">{t("public_clubs")}</Breadcrumb.Item>
                </Breadcrumb.Wrapper>
                <h1>{t("public_clubs")}</h1>
            </Container>
            <Form name={EForms.clubsSearch}>
                <Container>
                    <Control.Row>
                        <Control.Select
                            name="region"
                            placeholder={t("bo5x1ckzqn6")}
                            options={filteredRegions}
                            extra="input { background: white; border-radius: 4px; }"
                            menuProps={{ extra: `> * { max-width: fit-content; }` }}
                        />
                        {/*<Control.Select*/}
                        {/*    name="city"*/}
                        {/*    placeholder={t("ykxjslth2w")}*/}
                        {/*    options={filteredOptions.city}*/}
                        {/*    extra="input { background: white; border-radius: 4px; }"*/}
                        {/*    menuProps={{ extra: `> * { max-width: fit-content; }` }}*/}
                        {/*/>*/}
                        <Control.Select
                            name="universityId"
                            placeholder={'Университет'}
                            options={clubsUniversOptions}
                            extra="input { background: white; border-radius: 4px; }"
                            menuProps={{ extra: `> * { max-width: fit-content; }` }}
                        />

                    </Control.Row>
                </Container>
            </Form>
            <Container
                className={"unis_wrapper"}
                extra="flex-direction: row; flex-wrap: wrap; justify-content: flex-start; width: 100%; gap: 15px; margin-top: 15px; a { width: calc((100% - 15px * 2) / 3); };"
            >
                {visibleClubs.filter(x => (x.onModeration != true)).map((club) => (
                    <Link className={"uni_link"} key={club.id} to={`/club/${club.id}`}>
                        <ClubsTab.Component club={club} />
                    </Link>
                ))}
            </Container>
            <Container>
                <PaginationControl pagination={pagination} />
            </Container>
        </>
    );
};

const ClubsTab = {
    Component: (props) => {
        const { t } = useTranslation();

        const { club: clubProps } = props;
        const { details: club, id: clubId, universityId } = clubProps;
        const rooms = useStorageListener((state) => _.values(state?.rooms)?.filter((room) => room.clubId === clubId));
        const now = Date.now();
        const events = useStorageListener((state) => _.values(state?.events)?.filter((event) =>
            event.universityId === universityId &&
            event.onModeration !== true &&
            event.hideFromAll !== true &&
            (event.details?.dates?.to || event.details?.dates?.from) >= now
        ));
        let photos = _.get(club, "photos");
        let photo = (photos == undefined || photos.length == 0) ? undefined : photos[0];
        return (
            <ClubsTab.Wrapper>
                <ClubsTab.Photo src={resolveFileUrl(photo)} />
                <ClubsTab.Body>
                    <h3>{_.get(club, "name")}</h3>
                    <div className="region">{_.get(club, "region")}</div>
                    {/*<RowWrapper>*/}
                    {/*    <div>Доступно мест:</div>*/}
                    {/*    <strong>-</strong>*/}
                    {/*</RowWrapper>*/}
                    <RowWrapper>
                        <div>{t("8gn9igbauq8")}</div>
                        <strong>
                            {events.length} {t("awl9xdgtpsa")}
                        </strong>
                    </RowWrapper>
                </ClubsTab.Body>
            </ClubsTab.Wrapper>
        );
    },
    Wrapper: styled(Frame)`
        width: 100%;
        border-radius: 12px;
        overflow: hidden;
        border: 1px solid ${({ theme }) => theme.halfblue};
        box-sizing: border-box;
    `,
    Photo: styled(Frame)<{ src?: string }>`
        width: 100%;
        height: 224px;
        background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    Body: styled(Frame)`
        width: 100%;
        padding: 20px;
        box-sizing: border-box;
        align-items: flex-start;
        justify-content: flex-start;
        gap: 8px;

        * {
            display: flex;
        }

        h3 {
            margin: 8px 0;
        }

        .region {
            font-size: 13px;
            line-height: 17px;
            color: ${({ theme }) => theme.blue};
        }
    `,
};

const Form = styled.form`
    display: flex;
    padding: 56px 0;
    width: 100%;
    background: ${({ theme }) => theme.lightblue};
    justify-content: center;
`;

export default ClubsPage;
